module.exports = __webpack_public_path__ + "img/stock7.f71e5093.png";